import React from 'react';
import { useStockNewsQuery } from '../../../../services/cryptoNewsAPI';
import Spinner from '../../../utils/Spinner';
import StockNewsCard from "./StockNewsCard";

const StockNews = ({stock}) => {    
    const {data, isFetching} = useStockNewsQuery(stock);
    const stockNews = data?.value;
    
    return (
        <div className="row py-2 ">
            {
                isFetching
                ? <Spinner />
                :  
                stockNews?.map((news,i) => (
                    <StockNewsCard key={i} news={news}/>
                ))
            }
        </div>
    )
}

export default StockNews
